$(document).ready(function(){
    if ($(".product-form__radio").length) {
        const variant = $(".product-form__radio:checked").val();
        $(".product-variant-title").text(variant);
    }

    $(document).on("click", ".product-form__label", function(e) {
		const variant = $(this).find(".text").text();
        console.log("variant: ", variant);
        $(".product-variant-title").text(variant);
	})
});